module.exports = __webpack_public_path__ + "static/media/left.093cd99c.png";